export class ReportExampleFileModel {
	url?:string = '';
	fileName: string = '';
	content: string = '';
	loadingListAction: boolean = false;

	constructor(r?:Partial<ReportExampleFileModel>) {
		Object.assign(this, r)
	}

	hasBeenUploaded():boolean {
		return !!this.url
	}
}
